"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentAttachmentImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing DocumentAttachment operations. */
var DocumentAttachmentImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class DocumentAttachment class.
   * @param client Reference to the service client
   */
  function DocumentAttachmentImpl(client) {
    (0, _classCallCheck2["default"])(this, DocumentAttachmentImpl);
    this.client = client;
  }
  /**
   *  (Auth: RhinestoneAuthorize[hiveId, fullName, portalId])
   * @param portalId (Access Controlled)
   * @param hiveId (Access Controlled)
   * @param fullName (Access Controlled)
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(DocumentAttachmentImpl, [{
    key: "getDocumentAttachment",
    value: function getDocumentAttachment(portalId, hiveId, fullName, options) {
      var operationArguments = {
        portalId: portalId,
        hiveId: hiveId,
        fullName: fullName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getDocumentAttachmentOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[hiveId, fullName, portalId])
     * @param portalId (Access Controlled)
     * @param hiveId (Access Controlled)
     * @param fullName (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "getDocumentAttachmentOrPart",
    value: function getDocumentAttachmentOrPart(portalId, hiveId, fullName, options) {
      var operationArguments = {
        portalId: portalId,
        hiveId: hiveId,
        fullName: fullName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getDocumentAttachmentOrPartOperationSpec);
    }
  }]);
  return DocumentAttachmentImpl;
}(); // Operation Specifications


exports.DocumentAttachmentImpl = DocumentAttachmentImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getDocumentAttachmentOperationSpec = {
  path: "/api/Portals({portalId})/Documents/Attachments/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Stream"
        },
        serializedName: "parsedResponse"
      }
    },
    401: {},
    403: {},
    404: {}
  },
  queryParameters: [Parameters.identifier],
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName1],
  headerParameters: [Parameters.accept4],
  serializer: serializer
};
var getDocumentAttachmentOrPartOperationSpec = {
  path: "/api/Portals({portalId})/Documents/AttachmentOrPart/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Stream"
        },
        serializedName: "parsedResponse"
      }
    },
    206: {},
    401: {},
    403: {},
    406: {}
  },
  queryParameters: [Parameters.fileName],
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName1],
  headerParameters: [Parameters.accept4],
  serializer: serializer
};